import { gql } from '@apollo/client';
import { mutation } from 'services/graphql';

export const markAllNotificationsAsSeenMutation = gql`
  mutation markAllNotificationsAsSeen {
    markAllNotificationsAsSeen {
      success
      error
    }
  }
`;

export default mutation(markAllNotificationsAsSeenMutation);
